// Initialize theme object
window.theme = window.theme || {};

import '../scripts/legacy/theme.js';
import '../scripts/components/';
import '../scripts/utils/helpers';
import '../scripts/utils/analytics/klaviyo.js';

// Dispatch event when theme bundle is loaded
document.dispatchEvent(new CustomEvent('theme:loaded'));
window.theme.loaded = true;
